import { defineEntity, custom } from './_helpers.js';

export default defineEntity('ticket', {
    submitted:               custom({ scope: 'state' }),
    approved:                custom({ scope: 'state' }),
    rejected:                custom({ scope: 'state' }),
    returned:                custom({ scope: 'state' }),
    delegated:               custom({ scope: 'state' }),
    assigned:                custom({ scope: 'state' }),
    poolAssigned:            custom({ scope: 'state' }),
    claimed:                 custom({ scope: 'state' }),
    assignmentAccepted:      custom({ scope: 'state' }),
    assignmentRejected:      custom({ scope: 'state' }),
    resolved:                custom({ scope: 'state' }),
    closed:                  custom({ scope: 'state' }),
    cancelled:               custom({ scope: 'state' }),
    slaBreached:             custom({ scope: 'state' }),
    slaWarning:              custom({ scope: 'state' }),
    escalated:               custom({ scope: 'state' }),
    pendingDeleteApproved:   custom({ scope: 'state' }),
    pendingDeleteRejected:   custom({ scope: 'state' }),
    pendingStatusRejected:   custom({ scope: 'state' }),
    commented:               custom({ scope: 'state' }),
    'subtasks.allDoneSuggestion': custom({ scope: 'state' }),
});
